// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1ia50","fileBtn":"File_fileBtn__1-g1B","closeBtn":"File_closeBtn__gsX7U","fileSelected":"File_fileSelected__3zSWD","disabled":"File_disabled__20pYe"};